// extracted by mini-css-extract-plugin
export default {"tab":"tab-module--tab--tQwXG","isActive":"tab-module--is-active--IpcOz"};